import lazyScreen from '../utils/lazyScreen';
const IntegrationProviders = lazyScreen(() => import('../pages/integration/Providers/index.js'), 'pages/integration/Providers/index.js');
const IntegrationAuthCallback = lazyScreen(() => import('../pages/integration/AuthCallback/index.js'), 'pages/integration/AuthCallback/index.js');
const IntegrationConnectionDetail = lazyScreen(() => import('../pages/integration/ConnectionDetail/index.js'), 'pages/integration/ConnectionDetail/index.js');
const IntegrationOrders = lazyScreen(() => import('../pages/integration/Orders/index.js'), 'pages/integration/Orders/index.js');

export default [
    // Unified inbound orders — multi-tab page (sale + social).
    { path: '/integration/Orders', component: IntegrationOrders },

    // One provider configuration screen; legacy category URLs select their matching tab.
    { path: '/integration/providers', component: IntegrationProviders },

    { path: '/integration/providers/salechannel', component: IntegrationProviders },
    { path: '/integration/providers/social', component: IntegrationProviders },
    { path: '/integration/providers/advertising', component: IntegrationProviders },
    { path: '/integration/providers/message', component: IntegrationProviders },
    { path: '/integration/providers/reviews', component: IntegrationProviders },
    { path: '/integration/providers/affiliate', component: IntegrationProviders },
    { path: '/integration/providers/carrier', component: IntegrationProviders },
    { path: '/integration/providers/food', component: IntegrationProviders },

    { path: '/integration/provider/:provider_code', component: IntegrationConnectionDetail },
    { path: '/integration/auth-callback', component: IntegrationAuthCallback }
];
